export default "__VITE_ASSET__C1ssfI7V__"